import axiosInstance from "../utils/axiosInstance";

export async function getEmailSettings() {
  const { data } = await axiosInstance.get("/admin/email-settings");
  return data?.data ?? null;
}

export async function updateEmailSettings(payload) {
  const { data } = await axiosInstance.put("/admin/email-settings", payload);
  return data?.data ?? null;
}

export async function setEmailEnabled(enabled) {
  const { data } = await axiosInstance.patch("/admin/email-settings/enabled", {
    enabled,
  });
  return data?.data ?? null;
}

export async function sendTestEmail(testEmail) {
  const { data } = await axiosInstance.post("/admin/email-settings/test", {
    testEmail,
  });
  return data?.data ?? null;
}
